<template>
    <div v-if="data.datasets.length > 0">
        <Pie :data="data" :options="chartOptions" :style="style" />
    </div>
    <div v-else>
       <p class="text-center">Selecione um usuário para carregar os dados</p>
    </div>


</template>

<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'vue-chartjs'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
    props: {
        data: Array
    },
    components: { Pie },
    data() {
        return {
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        labels: {
                            generateLabels: (chart) => {
                                const originalLabels = ChartJS.overrides.pie.plugins.legend.labels.generateLabels.call(this, chart);
                                const total = chart.data.datasets[0].data.reduce((sum, value) => sum + parseFloat(value), 0);
                                return originalLabels.map((label, index) => {
                                    const value = chart.data.datasets[0].data[index];

                                    const percentage = ((value / total) * 100).toFixed(2); // Calculate percentage
                                    return {
                                        ...label,
                                        text: `${label.text} (${percentage}%)`, // Append percentage to label text
                                    };
                                });
                            },
                        },
                    },
                }
            },
            style: {
                height: '250px',
                width: '100%',
                position: 'relative',
            }
        }
    }
}
</script>